import React, { Component } from 'react';
import { object, bool } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';
import messageShape from 'shapes/message';
import connector from './connector';

class MonitorButton extends Component {
  openAnalyticsDrawer = () => {
    const { actions, message } = this.props;
    if (message.form) {
      actions.drawers.formAnalytics.open({ message });
    } else {
      actions.drawers.analytics.open(message);
    }
  };

  render() {
    const {
      isCompanyAdmin,
      isTeamAdmin,
      message: { formVisibleAll, form },
      channel,
    } = this.props;
    const { isAdmin = false, isDirect = false } = channel || {};
    if (!formVisibleAll && !isCompanyAdmin && !(isTeamAdmin && isDirect) && !isAdmin) return null;

    return (
      <Button
        variant="outlined"
        color="secondary"
        sx={theme => ({
          minWidth: '110px',
          color: theme.palette.primary.ultraDark,
        })}
        onClick={this.openAnalyticsDrawer}
      >
        {I18n.t(`AcknowledgementMessage.${form ? 'Results' : 'Monitor'}`)}
      </Button>
    );
  }
}

MonitorButton.propTypes = {
  message: messageShape.isRequired,
  isCompanyAdmin: bool.isRequired,
  isTeamAdmin: bool.isRequired,
  actions: object.isRequired,
  channel: object,
};

export default connector(MonitorButton);
